export default __webpack_public_path__ + "static/media/main-bg.0c1ae08c.png";